// extracted by mini-css-extract-plugin
var _1 = "use-delete-signal-confirm-modal_cancel_link__cNCwK";
var _2 = "use-delete-signal-confirm-modal_content__Kd1m+";
var _3 = "use-delete-signal-confirm-modal_footer__2yolz";
var _4 = "use-delete-signal-confirm-modal_footer_left__GPAh9";
var _5 = "use-delete-signal-confirm-modal_footer_right__RXzQf";
var _6 = "use-delete-signal-confirm-modal_signal_delete_modal__u6qZl";
export { _1 as "cancel_link", _2 as "content", _3 as "footer", _4 as "footer_left", _5 as "footer_right", _6 as "signal_delete_modal" }
